import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import TeamMoveDialogActions from 'actions/TeamMoveDialogActions';
import {Record} from 'immutable';

const State = Record({
  team: null,
});

@immutableStore
class TeamMoveDialogStore {
  constructor() {
    this.state = State();
    this.bindActions(TeamMoveDialogActions);
  }

  stageDepartmentToReceive(departmentId) {
    this.setState({team: this.state.team.set('departmentId', departmentId)});
  }

  openForTeam(team) {
    this.setState({team});
  }
}

export default alt.createStore(TeamMoveDialogStore);
